import { Injectable } from '@angular/core';

import { type NormCubicMeter } from '@clean-code/models';
import { FormBaseService } from '@clean-code/shared/util/util-component-services';
import { NormCubicMeterService } from '../services/norm-cubic-meter.service';

@Injectable({ providedIn: 'root' })
export class NormCubicMeterFormFacade extends FormBaseService<NormCubicMeter> {
  constructor(service: NormCubicMeterService) {
    super(service);
  }
}
